// extracted by mini-css-extract-plugin
export default {"toast":"notification_toast__CsKui"};